import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

import DateRangeInput from '../../Shared/DateRangeInput/DateRangeInput'

import { joinClassNames } from '../../../utils/styles'
import styles from './aggregation-header.module.scss'

interface IAnalyticsDataAggregationProps {
    aggregationType: string
    onAggregationChange: Dispatch<SetStateAction<string>>
    dateFrom: string
    dateTo: string
    onDateChange: (field: string, value: string) => void
}

function AnalyticsDataAggregation(props: IAnalyticsDataAggregationProps) {
    const {
        aggregationType,
        onAggregationChange,
        dateFrom,
        dateTo,
        onDateChange,
    } = props

    const { t } = useTranslation()

    return (
        <div className={styles.aggregationHeader}>
            <div className={styles.aggregationHeader__tabsWrapper}>
                <p>{t('aggregate_by')}</p>
                <div className={styles.aggregationHeader__tabs}>
                    {['day', 'week', 'month'].map((type) => (
                        <button
                            className={joinClassNames(
                                styles.aggregationHeader__tab,
                                aggregationType === type &&
                                    styles.aggregationHeader__tabActive
                            )}
                            key={type}
                            onClick={() => onAggregationChange(type)}
                        >
                            {t(type)}
                        </button>
                    ))}
                </div>
            </div>

            <DateRangeInput
                dateFrom={dateFrom}
                dateTo={dateTo}
                onDateChange={onDateChange}
            />
        </div>
    )
}

export default AnalyticsDataAggregation
